<template>
  <div>
    <p class="d-flex justify-content-between">
      <span>Subdisciplinas de la disciplina</span>
      <a href="#" @click.prevent="" data-toggle="modal" data-target="#add-subdiscipline-modal"
        class="d-block btn btn-outline-primary">Agregar subdisciplina</a>
    </p>
    <table class="table table-sm table-bordered mt-3">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Clave</th>
        <th>Nombre</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="loading">
        <td colspan="5" class="text-center">
          <spinner class="text-success" small/>
        </td>
      </tr>
      <tr v-for="(subdiscipline, index) in subdisciplines"
          v-if="!loading"
          :key="subdiscipline.id">
        <td class="text-center">{{ index + 1 }}</td>
        <td class="text-center">{{ subdiscipline.key.toUpperCase() }}</td>
        <td>{{ subdiscipline.title }}</td>
        <td>
          <a :href="`/catalogo/subdisciplinas/${subdiscipline.id}/editar`" class="btn btn-sm btn-secondary" type="button">Editar</a>
          <button class="btn btn-sm btn-danger" type="button" @click="showDeleteDialog(subdiscipline)">Eliminar
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    
    <ok-cancel-dialog title="Eliminar subdisciplina"
                      content="¿Desvincular la subdisciplina de la disciplina?"
                      @ok-button-pressed="destroySubdiscipline"
                      :id="`delete-subdiscipline-dialog-${uuid}`"
                      ref="delete-subdiscipline-modal"></ok-cancel-dialog>
    
    <add-subdiscipline-modal :discipline="discipline"
                            @subdiscipline-saved="load"></add-subdiscipline-modal>
  </div>
</template>

<script>
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions } from 'vuex'
  import Spinner from '../ui/Spinner'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import AddSubdisciplineModal from './AddSubdisciplineModal'
  
  export default {
    name: 'SubdisciplinesTable',
    components: {
      Spinner,
      OkCancelDialog,
      AddSubdisciplineModal,
    },
    props: {
      discipline: Object,
    },
    data () {
      return {
        loading: false,
        uuid: Math.guid(),
        subdisciplines: [],
        subdiscipline: null,
      }
    },
    methods: {
      ...mapActions({
        deleteSubdiscipline: 'catalogs/deleteSubdiscipline',
      }),

      showDeleteDialog (subdiscipline) {
        this.subdiscipline = subdiscipline

        $(`#delete-subdiscipline-dialog-${this.uuid}`).modal('show')
      },

      async destroySubdiscipline () {
        this.$refs['delete-subdiscipline-modal'].sending = true
        
        const response = await this.deleteSubdiscipline({
          subdiscipline: this.subdiscipline,
        })
        
        const {
                message,
                error,
              } = response.data.data
        
        if (error) {
          AlertManager.error(error)
        } else {
          AlertManager.notification(message)
        }

        await this.load()
        
        this.$refs['delete-subdiscipline-modal'].sending = false
        this.$refs['delete-subdiscipline-modal'].close()
      },
      
      async load() {
        this.loading = true
  
        const { data } = await axios.get('/subdisciplines', {
          params: {
            discipline: discipline.id,
            pagination: false,
          },
        })
  
        this.subdisciplines = data.data
        this.loading     = false
      }
    },
    async mounted () {
      await this.load()
    },
  }
</script>
